export default {
      id: "color_hh-thin-usage",
      viewBox: "0 0 132 146",
      url: __webpack_public_path__ + "sprite.svg#color_hh-thin",
      toString: function () {
        return this.url;
      }
    }